import React from 'react';

import { cn } from '../../../lib/cn';
import type { SessionCurriculumSlice } from '../../types/coursePlan';
import {
  curriculumDimensionBadgeClass,
  curriculumDimensionBadgeLabel,
} from '../../lib/hitoCurriculumUi';

interface CurriculumDimensionBadgeProps {
  slice: SessionCurriculumSlice;
  className?: string;
}

export function CurriculumDimensionBadge({ slice, className }: CurriculumDimensionBadgeProps) {
  return (
    <span
      className={cn(
        'rounded-md px-2 py-0.5 text-[10px] font-medium tracking-tight',
        curriculumDimensionBadgeClass(slice.dimensionDominante),
        className,
      )}
      title={curriculumDimensionBadgeLabel(slice)}
    >
      {curriculumDimensionBadgeLabel(slice)}
    </span>
  );
}
